export default __webpack_public_path__ + "static/media/AWS-DDI.0296a3a1.png";